import {forwardRef, useEffect, useImperativeHandle, useRef, useState} from "react";
import {IconClose} from "../../Icon";
import {Button, Checkbox, ConfigProvider, message, Modal} from "antd";
import {t} from "i18next";
import {isStringNullOrEmpty} from "../../utils";
import {
    ARRAY_TASKS, ARRAY_TASKS_FOR_TYPE_SWITCHER_LIST,
    GET_ARRAY_LIBRARY_TYPES,
    IMPORT_FILE_MODE_IMPORTMODE, KEY_TASK_TYPE_SWITCHER,
    KEY_TYPE_SWITCHER,
    MENU_SEPARATOR
} from "../../Const";
import {ipcInvoke} from "../../common/ipc";

const DialogTaskTypeSwitcher = forwardRef((props:{onCloseCallback:any}, ref) => {
    useImperativeHandle(ref, () => ({
        onShowDialog: onShowDialog
    }))
    const [isShowDialog, setIsShowDialog] = useState(false);
    const mCallbackRef = useRef(null);

    const ARRAY_DEFAULT_TASKS = [
        {
            value:'today',
            label:t("Today"),
            icon:''
        },
        {
            value:'upcoming',
            label:t("Upcoming"),
            icon:''
        },
        {
            value:'overdue',
            label:t("Overdue"),
            icon:''
        },
    ]

    const [arrayLibraryTypes,setArrayLibraryTypes] = useState(ARRAY_TASKS_FOR_TYPE_SWITCHER_LIST());

    useEffect(()=>{

    },[])

    const onShowDialog = (callback:any)=>{
        setIsShowDialog(true);
        mCallbackRef.current = callback;

        const szTypeSwitcher = localStorage.getItem(KEY_TASK_TYPE_SWITCHER);
        let jsonSelected = ARRAY_DEFAULT_TASKS;
        if (szTypeSwitcher){
            jsonSelected = JSON.parse(szTypeSwitcher);
        }

        const arrayNewLibraryTypes = [...arrayLibraryTypes];
        for (let i=0;i<arrayNewLibraryTypes.length;i++){
            const item = arrayNewLibraryTypes[i];
            if (jsonSelected.some(p=>p.value == item.value)){
                item.isSelected = true;
            }else{
                item.isSelected = false;
            }
        }
        setArrayLibraryTypes(arrayNewLibraryTypes);
    }

    return <Modal width={468} zIndex={2005}
                  afterClose={() => {
                      props.onCloseCallback();
                  }}
                  open={isShowDialog} centered={true} closable={true} closeIcon={<IconClose/>} footer={null}
                  onCancel={() => {
                      setIsShowDialog(false)
                  }}>
        <div style={{height: '100%', width: '100%', display: 'flex', flexDirection: 'column'}}>
            <div className={'flex-row-vertical-center'} style={{flexShrink: '0'}}>
                <span className={'dialog-title'}>{t("TypeSwitcherSetting")}</span>
                <div style={{flexGrow: '1'}}/>
            </div>
            <div className={'line mt-12'} style={{margin: '12px -22px'}}></div>

            {/*<span className={'dialog-title'}>{t("Visible types")}</span>*/}
            <span style={{color:'var(--color-666666)',marginTop:'10px',fontSize:'12px'}}>{t("SelectTypesToDisplay")}</span>
            <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:'12px',marginTop:'16px'}}>
                {
                    arrayLibraryTypes.map(p=>{
                        return(<div className={'flex-row-vertical-center cursor-pointer'} style={{borderRadius:'8px',
                            border:p.isSelected?'1px solid var(--primary-color)':'1px solid var(--border-color)',
                            background:p.isSelected?'#3670F71A':'transparent',
                            height:'44px',padding:'0 10px'}} onClick={()=>{
                            const arrayNewLibrarys = [...arrayLibraryTypes];
                            if (p.isSelected) {
                                //取消选中
                                p.isSelected = false;
                                setArrayLibraryTypes(arrayNewLibrarys);
                            }else {
                                const nCount = arrayNewLibrarys.filter(p => p.isSelected).length;
                                if (nCount < 5) {
                                    p.isSelected = true;
                                    setArrayLibraryTypes(arrayNewLibrarys);
                                }else {
                                    message.destroy();
                                    message.error(t('Maximum5Allowed'));
                                }
                            }
                        }}>
                            <Checkbox checked={p.isSelected}/>
                            <span className={'ml-10'}>{p.label}</span>
                        </div>)
                    })
                }
            </div>


            <div className={'flex-row-vertical-center mt-32 mb-4'} style={{alignSelf:'flex-end'}}>
                <Button
                    style={{height: '34px', minWidth: '80px'}}
                    className='large-w-button button-border-gray-style font-size-14 font-family-medium'
                    onClick={() => {
                        setIsShowDialog(false);
                    }}>{t("Cancel")}</Button>
                <Button
                    // disabled={isStringNullOrEmpty(selectFile)}
                    className='large-w-button button-solid-style font-size-14 font-family-medium'
                    type="primary"
                    onClick={async () => {
                        setIsShowDialog(false);
                        props.onCloseCallback();
                        //保存选择的..
                        const arraySelected = arrayLibraryTypes.filter(p=>p.isSelected);
                        mCallbackRef?.current(arraySelected);
                    }}
                    style={{
                        marginLeft: '12px',
                        minWidth: '120px'
                    }}>{t("Save changes")}</Button>
            </div>
        </div>
    </Modal>
})

export default DialogTaskTypeSwitcher;






































